import React from 'react';

const StripeLogo = () => (
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20" fillRule="evenodd" clipRule="evenodd" strokeMiterlimit="1.414">
      <path
         fill="#000"
         fillRule="nonzero"
         d="M9.307 6.1C7.86 5.563 7.07 5.15 7.07 4.494c0-.554.455-.87 1.267-.87 1.485 0 3.01.573 4.06 1.088l.593-3.663C12.158.65 10.455 0 8.1 0 6.435 0 5.05.436 4.06 1.248c-1.03.85-1.565 2.08-1.565 3.564 0 2.693 1.644 3.84 4.317 4.812 1.723.614 2.297 1.05 2.297 1.722 0 .654-.56 1.03-1.57 1.03-1.25 0-3.31-.614-4.66-1.406l-.6 3.703C3.44 15.327 5.58 16 7.8 16c1.76 0 3.228-.416 4.218-1.208 1.11-.87 1.684-2.158 1.684-3.822 0-2.752-1.683-3.9-4.396-4.87z "
      />
   </svg>
);

export default StripeLogo;
